/**
 * @generated SignedSource<<d9e81db4628ced751ec31cc6f143ac75>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeedbackCastPanelHoveredVoterQuery$variables = {
  voter: string;
};
export type FeedbackCastPanelHoveredVoterQuery$data = {
  readonly delegate: {
    readonly " $fragmentSpreads": FragmentRefs<"VoterCardFragment">;
  };
};
export type FeedbackCastPanelHoveredVoterQuery = {
  response: FeedbackCastPanelHoveredVoterQuery$data;
  variables: FeedbackCastPanelHoveredVoterQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "voter"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "addressOrEnsName",
    "variableName": "voter"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TokenAmount",
    "kind": "LinkedField",
    "name": "amount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tokenId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accessory",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "background",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "glasses",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "head",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FeedbackCastPanelHoveredVoterQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Delegate",
        "kind": "LinkedField",
        "name": "delegate",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "VoterCardFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FeedbackCastPanelHoveredVoterQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Delegate",
        "kind": "LinkedField",
        "name": "delegate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DelegateStatement",
            "kind": "LinkedField",
            "name": "statement",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "twitter",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "discord",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "statement",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "summary",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LiquidDelegationProxy",
            "kind": "LinkedField",
            "name": "liquidDelegationProxy",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Address",
            "kind": "LinkedField",
            "name": "address",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ResolvedName",
                "kind": "LinkedField",
                "name": "resolvedName",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "address",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VotingPower",
            "kind": "LinkedField",
            "name": "tokensRepresented",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "currentlyActive": true
                }
              }
            ],
            "concreteType": "LiquidDelegationRepresentation",
            "kind": "LinkedField",
            "name": "liquidRepresentation",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Delegate",
                "kind": "LinkedField",
                "name": "proxy",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Noun",
                    "kind": "LinkedField",
                    "name": "nounsRepresented",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "liquidRepresentation(filter:{\"currentlyActive\":true})"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Noun",
            "kind": "LinkedField",
            "name": "nounsRepresented",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "VotingPower",
            "kind": "LinkedField",
            "name": "totalTokensRepresented",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DelegateMetrics",
            "kind": "LinkedField",
            "name": "delegateMetrics",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalVotes",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "da17dc70d8290cb40d725ccb7c5048ed",
    "id": null,
    "metadata": {},
    "name": "FeedbackCastPanelHoveredVoterQuery",
    "operationKind": "query",
    "text": "query FeedbackCastPanelHoveredVoterQuery(\n  $voter: String!\n) {\n  delegate(addressOrEnsName: $voter) {\n    ...VoterCardFragment\n    id\n  }\n}\n\nfragment DelegateProfileImageFragment on Delegate {\n  tokensRepresented {\n    amount {\n      amount\n    }\n  }\n  liquidRepresentation(filter: {currentlyActive: true}) {\n    proxy {\n      nounsRepresented {\n        __typename\n        id\n      }\n      id\n    }\n  }\n  ...NounGridFragment\n}\n\nfragment NounGridFragment on Delegate {\n  tokensRepresented {\n    amount {\n      amount\n    }\n  }\n  liquidRepresentation(filter: {currentlyActive: true}) {\n    proxy {\n      nounsRepresented {\n        id\n        ...NounImageFragment\n      }\n      id\n    }\n  }\n  nounsRepresented {\n    id\n    ...NounImageFragment\n  }\n}\n\nfragment NounImageFragment on Noun {\n  tokenId\n  accessory\n  background\n  body\n  glasses\n  head\n}\n\nfragment NounResolvedNameFragment on ResolvedName {\n  address\n  name\n}\n\nfragment VoterCardFragment on Delegate {\n  ...VoterPanelActionsFragment\n  ...DelegateProfileImageFragment\n  address {\n    resolvedName {\n      address\n      name\n      ...NounResolvedNameFragment\n    }\n  }\n  statement {\n    statement\n    summary\n  }\n  id\n  totalTokensRepresented {\n    amount {\n      amount\n    }\n  }\n  delegateMetrics {\n    totalVotes\n  }\n}\n\nfragment VoterPanelActionsDelegateButtonFragment on Delegate {\n  liquidDelegationProxy {\n    __typename\n  }\n  address {\n    resolvedName {\n      address\n    }\n  }\n}\n\nfragment VoterPanelActionsFragment on Delegate {\n  statement {\n    twitter\n    discord\n  }\n  ...VoterPanelActionsDelegateButtonFragment\n}\n"
  }
};
})();

(node as any).hash = "117375dde5803ce4115eb53ad3ac7a3c";

export default node;
